// extracted by mini-css-extract-plugin
module.exports = {"breakpointTablet":"991px","breakpointMobileLandscape":"820px","slider":"videoSlider-module--slider--3CWAR"};